import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { createRoutine } from 'redux-saga-routines';
import { ContainerState, I_Sponsor } from './typesIndex';

// The initial state of the App container
export const initialState: ContainerState = {
  loading: false,
  success: false,
  error: false,
  sponsor: null,
};

export const GET_SPONSOR_PAGE = createRoutine('sponsor/getSponsor');

const sponsorSlice = createSlice({
  name: 'sponsor',
  initialState,
  reducers: {
    resetStatusPage(state) {
      state.loading = initialState.loading;
      state.error = initialState.error;
      state.success = initialState.success;
    },
  },
  extraReducers: {
    [HYDRATE]: (state: ContainerState, action: PayloadAction<any>) => ({
      ...state,
      ...action.payload.sponsor,
    }),

    /**
     * ! GET SPONSOR
     */
    [GET_SPONSOR_PAGE.TRIGGER]: (
      state,
      // action: PayloadAction<{ id: string }>,
    ) => {
      state.loading = true;
      state.success = false;
      state.error = false;
    },
    [GET_SPONSOR_PAGE.SUCCESS]: (state, action: PayloadAction<I_Sponsor>) => {
      state.sponsor = action.payload;
      state.loading = false;
      state.success = true;
      state.error = false;
    },
    [GET_SPONSOR_PAGE.FAILURE]: state => {
      state.loading = false;
      state.success = false;
      state.error = true;
    },
  },
});

export const { actions, reducer, name: sliceKey } = sponsorSlice;

export default reducer;
